import { useState } from "react";

const ADD_STEP = {
  CREATE: "CREATE",
  SAVE: "SAVE",
};

const useHooks = () => {
  const [tagLabelValue, setTagLabelValue] = useState("");
  const [currStep, setCurrStep] = useState(ADD_STEP.SAVE);
  const [selectedOpt, setSelectedOpt] = useState(null);
  const [ipAddressInputValue, setIpAddressInputValue] = useState("");

  return {
    tagLabelValue,
    setTagLabelValue,
    ADD_STEP,
    setCurrStep,
    currStep,
    selectedOpt,
    setSelectedOpt,
    ipAddressInputValue,
    setIpAddressInputValue,
  };
};

export { useHooks };
